import {Company} from "@/models/entities/providers/Company";

export class Provider extends Company {    
    contactPersonName:string = "";
    contactPersonEmail:string = "";
    contactPersonPhoneNumber:string = "";
    companyIdCode:string = "";
    info:string = "";
    isContactPerson:boolean = false;
    idCode:string = "";
    hasAdmin:boolean = false;
}